@if (isRendered$()) {
  <div
    class="lab-banner"
    [class.lab-banner--open]="isOpen$()"
    [class.lab-banner--closing]="!isOpen$()"
    [class.lab-banner--overlay]="dismissible"
    [class.lab-banner--inline]="!dismissible"
    [class.lab-banner--info]="mood === 'info'"
    [class.lab-banner--success]="mood === 'success'"
    [class.lab-banner--warning]="mood === 'warning'"
    [class.lab-banner--danger]="mood === 'danger'"
    [attr.role]="resolvedRole"
    (transitionend)="onTransitionEnd($event)"
  >
    <div class="lab-banner__main">
      <lab-icon class="lab-banner__icon" [name]="resolvedIcon" size="32" aria-hidden="true" />

      <div class="lab-banner__copy">
        @if (heading$().text.trim()) {
          <div class="lab-banner__title">{{ heading$() | translate }}</div>
        }

        @if (description$().text.trim()) {
          <div class="lab-banner__description">{{ description$() | translate }}</div>
        }
      </div>
    </div>

    <!-- Controls only exist when there is an action or dismiss affordance, so empty chrome vanishes from the DOM. -->
    @if (hasActions$() || dismissible) {
      <div class="lab-banner__actions">
        @if (action$(); as action) {
          <lab-button
            class="lab-banner__action"
            [variant]="action.variant ?? SolButtonType.secondary"
            [mood]="actionButtonMood(action)"
            [text]="action.text"
            [icon]="action.icon"
            [appendIcon]="action.appendIcon"
            [disabled]="action.disabled ?? false"
            [loading]="action.loading ?? false"
            [ariaLabel]="action.ariaLabel"
            (click)="onActionPress(action)"
          />
        }

        @if (secondaryAction$(); as action) {
          <lab-button
            class="lab-banner__action"
            [variant]="action.variant ?? SolButtonType.transparent"
            [mood]="action.mood ?? 'default'"
            [text]="action.text"
            [icon]="action.icon"
            [appendIcon]="action.appendIcon"
            [disabled]="action.disabled ?? false"
            [loading]="action.loading ?? false"
            [ariaLabel]="action.ariaLabel"
            (click)="onSecondaryActionPress(action)"
          />
        }

        @if (dismissible) {
          <button type="button" class="lab-banner__dismiss" aria-label="Dismiss banner" (click)="onDismissPress()">
            <lab-icon [name]="dismissIcon" size="14" aria-hidden="true" />
          </button>
        }
      </div>
    }
  </div>
}
